import Vue from 'vue';

import Router from 'vue-router';

import store from '../store'; // vuex

import i18n from '@/i18n/index.js';

import { getLocalStorage } from '@l/localStorage.js';
import deviceRoute from './modules/device';
import advancedServiceRoute from './modules/advancedService';

Vue.use(Router);

const getRoutes = () => {
  return [
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '/firstPage',
      component: (resolve) => require(['@/views/login/firstPage'], resolve), // 登录页面
      children: [
        {
          path: '/login',
          name: 'login',
          component: (resolve) => require(['@/views/login/login'], resolve) // 登录
        },
        // {
        //     path: '/forgetPassword',
        //     name: 'forgetPassword',
        //     component: resolve => require(['@/views/login/forgetPassword'], resolve) // 忘记密码
        // },
        {
          path: '/resetPass',
          name: 'resetPass',
          component: (resolve) => require(['@/views/login/resetPass'], resolve) // 重置密码
        },
        {
          path: '/register',
          name: 'register',
          component: (resolve) => require(['@/views/login/register'], resolve) // 注册
        }
        // {
        //     path: '/identity',
        //     name: 'identity',
        //     component: resolve => require(['@/views/login/identity'], resolve) // 身份选择
        // },
      ]
    },
    {
      path: '/home',
      component: (resolve) => require(['@/views/home'], resolve), // 首页
      meta: { requireAuth: true, noAuth: true },
      children: [
        // {
        //     path: '/personal', // 个人中心
        //     name: 'personal',
        //     component: resolve => require(['@/views/userList/personal'], resolve), // 个人中心
        //     meta: { requireAuth: true, active: 'personal', noAuth: true, bread: [{ name: '个人中心', icon: 'iconIocn-Accountnumber' }] }
        // },

        // 应用管理
        {
          path: '/applyList',
          name: 'applyList',
          component: (resolve) => require(['@/views/apply/applyList'], resolve), // 应用列表
          meta: {
            requireAuth: true,
            active: 'applyList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.apply'), icon: 'ux_icon_menu' },
              { name: i18n.t('HT.router.applyList') }
            ]
          }
        },
        {
          path: '/recoveryList',
          name: 'recoveryList',
          component: (resolve) => require(['@/views/apply/recoveryList'], resolve), // 回收列表
          meta: {
            requireAuth: true,
            active: 'recoveryList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.apply'), icon: 'ux_icon_menu' },
              { name: i18n.t('MN.app.recycle') }
            ]
          }
        },
        {
          path: '/applyInfo/:id',
          name: 'applyInfo',
          component: (resolve) => require(['@/views/apply/applyInfo'], resolve), // 应用详情
          meta: {
            requireAuth: true,
            active: 'applyList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.apply') },
              { name: i18n.t('HT.router.applyList'), url: '/applyList' },
              { name: i18n.t('HT.router.applyDetail') }
            ]
          }
        },

        // 产品管理
        {
          path: '/myline',
          name: 'myline',
          component: (resolve) => require(['@/views/myline/myLine'], resolve), // 额度管理
          meta: {
            requireAuth: true,
            active: 'myline',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.product'), icon: 'ux_icon_authority' },
              { name: i18n.t('HT.router.myline') }
            ]
          }
        },
        {
          path: '/productAll',
          name: 'productAll',
          component: (resolve) => require(['@/views/product/productAll'], resolve), // 产品总览
          meta: {
            requireAuth: true,
            active: 'productAll',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.product'), icon: 'ux_icon_visit' },
              { name: i18n.t('HT.router.productAll') }
            ]
          }
        },
        {
          path: '/productAllInfo',
          name: 'productAllInfo',
          component: (resolve) => require(['@/views/product/productAllInfo'], resolve), // 产品详情
          meta: {
            requireAuth: true,
            active: 'productAll',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.product'), icon: 'ux_icon_visit' },
              { name: i18n.t('HT.router.productAll'), icon: 'ux_icon_visit', url: '/productAll' },
              { name: i18n.t('HT.router.productDetail') }
            ]
          }
        },
        {
          path: '/faceLibrary',
          name: 'faceLibrary',
          component: (resolve) => require(['@/views/face/faceLibrary'], resolve), // 人脸库管理
          meta: {
            requireAuth: true,
            active: 'faceLibrary',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.product'), icon: 'ux_icon_visit' },
              { name: i18n.t('HT.face.library') }
            ]
          }
        },
        {
          path: '/flowDetail',
          name: 'flowDetail',
          component: (resolve) => require(['@/views/product/flowDetail'], resolve), // 流量详情
          meta: {
            requireAuth: false,
            acive: 'flowDetail',
            noAuth: false,
            bread: [
              {name: i18n.t('HT.router.product'), icon: 'ux_icon_visit'},
              {name: i18n.t('HT.product.flux')}
            ]
          }
        },
        // 接口管理
        {
          path: '/productList',
          name: 'productList',
          component: (resolve) => require(['@/views/product/productList'], resolve), // 产品列表
          meta: {
            requireAuth: true,
            active: 'productList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api2'), icon: 'ux_icon_visit' },
              { name: i18n.t('HT.router.product') }
            ]
          }
        },
        {
          path: '/product/type',
          name: 'productType',
          component: (resolve) => require(['@/views/product/productType'], resolve), // 产品类型
          meta: {
            requireAuth: true,
            active: 'product/type',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api2'), icon: 'ux_icon_visit' },
              {name: i18n.t('HT.router.productType')}
            ]
          }
        },
        {
          path: '/productInfo',
          name: 'productInfo',
          component: (resolve) => require(['@/views/product/productInfo'], resolve), // 产品详情
          meta: {
            requireAuth: true,
            active: 'productList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api') },
              { name: i18n.t('HT.router.product'), url: '/productList' },
              { name: i18n.t('HT.router.productDetail') }
            ]
          }
        },
        {
          path: '/product/quota',
          name: 'subordinateQuota',
          component: () => import('@/views/subordinate/quota'),
          meta: {
            requireAuth: true,
            active: 'product/quota',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.product'), icon: 'ux_icon_visit' },
              { name: i18n.t('HT.menu.product.quota') }
            ]
          }
        },
        {
          path: '/product/permission',
          name: 'subordinatePermission',
          component: () => import('@/views/subordinate/permission'),
          meta: {
            requireAuth: true,
            active: 'product/permission',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.product'), icon: 'ux_icon_visit' },
              { name: i18n.t('HT.menu.product.permission') }
            ]
          }
        },
        {
          path: '/groupList',
          name: 'groupList',
          component: (resolve) => require(['@/views/group/groupList'], resolve), // API分组
          meta: {
            requireAuth: true,
            active: 'groupList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('MN.api.category.group') }
            ]
          }
        },
        {
          path: '/groupInfo',
          name: 'groupInfo',
          component: (resolve) => require(['@/views/group/groupInfo'], resolve), // 分组详情
          meta: {
            requireAuth: true,
            active: 'groupList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              {
                name: i18n.t('HT.router.api.groupList'),
                icon: 'ux_icon_filter',
                url: '/groupList'
              },
              { name: i18n.t('HT.router.groupDetail') }
            ]
          }
        },
        {
          path: '/apiList',
          name: 'apiList',
          component: (resolve) => require(['@/views/apiServices/apiList'], resolve), // API列表
          meta: {
            requireAuth: true,
            active: 'apiList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.productAll.api') }
            ]
          }
        },
        {
          path: '/addApi',
          name: 'addApi',
          component: (resolve) => require(['@/views/apiServices/template/addApi'], resolve), // 添加API
          meta: {
            requireAuth: true,
            active: 'apiList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.apiList'), icon: 'ux_icon_filter', url: '/apiList' },
              { name: i18n.t('HT.router.addApi') }
            ]
          }
        },
        {
          path: '/swagger',
          name: 'swagger',
          component: (resolve) => require(['@/views/apiServices/template/swagger'], resolve), // swagger导入
          meta: {
            requireAuth: true,
            active: 'apiList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.apiList'), icon: 'ux_icon_filter', url: '/apiList' },
              { name: i18n.t('HT.router.swagger') }
            ]
          }
        },
        {
          path: '/apiInfo/:id',
          name: 'apiInfo',
          component: (resolve) => require(['@/views/apiServices/apiInfo'], resolve), // API详情
          meta: {
            requireAuth: true,
            active: 'apiList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.apiList'), icon: 'ux_icon_filter', url: '/apiList' },
              { name: i18n.t('HT.router.apiDetail') }
            ]
          }
        },
        {
          path: '/apiCode',
          name: 'apiCode',
          component: (resolve) => require(['@/views/apiServices/apiCode'], resolve), // api code
          meta: {
            requireAuth: true,
            active: 'apiCode',
            noAuth: false,
            bread: [{ name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' }, { name: 'API Code' }]
          }
        },
        {
          path: '/flowList',
          name: 'flowList',
          component: (resolve) => require(['@/views/apiServices/flowList'], resolve), // 流量控制
          meta: {
            requireAuth: true,
            active: 'flowList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.flowList') }
            ]
          }
        },
        {
          path: '/flowInfo/:id',
          name: 'flowInfo',
          component: (resolve) => require(['@/views/apiServices/flowInfo'], resolve), // 流量控制详情
          meta: {
            requireAuth: true,
            active: 'flowList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.flowList'), icon: 'ux_icon_filter', url: '/flowList' },
              { name: i18n.t('HT.router.flowListDetail') }
            ]
          }
        },
        {
          path: '/access',
          name: 'access',
          component: (resolve) => require(['@/views/apiServices/access'], resolve), // 访问策略
          meta: {
            requireAuth: true,
            active: 'access',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.access') }
            ]
          }
        },
        {
          path: '/accessInfo',
          name: 'accessInfo',
          component: (resolve) => require(['@/views/apiServices/accessInfo'], resolve), // 访问策略详情
          meta: {
            requireAuth: true,
            active: 'access',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.access'), icon: 'ux_icon_filter', url: '/access' },
              { name: i18n.t('HT.router.accessDetail') }
            ]
          }
        },

        // 服务
        {
          path: '/service',
          name: 'service',
          component: (resolve) => require(['@/views/service/service'], resolve), // 服务
          meta: {
            requireAuth: true,
            active: 'service',
            noAuth: false,
            bread: [{ name: i18n.t('HT.router.service'), icon: 'ux_icon_visit' }]
          }
        },

        // 生成Api（暂时未回退到详情页）
        {
          path: '/generateApi',
          name: 'generateApi',
          component: (resolve) => require(['@/views/product/generateApi'], resolve), // API文档
          meta: {
            requireAuth: true,
            active: 'productList',
            noAuth: true,
            bread: [
              { name: i18n.t('HT.router.productList') },
              { name: i18n.t('HT.router.productDetail'), icon: 'ux_icon_menu', url: '-1' },
              { name: i18n.t('HT.router.productList.api') }
            ]
          }
        },
        // API调试工具
        {
          path: '/debugg',
          name: 'debugg',
          component: (resolve) => require(['@/views/debugg/debug1'], resolve), // API调试工具
          meta: {
            requireAuth: true,
            active: 'debugg',
            noAuth: true,
            bread: [
              { name: i18n.t('HT.router.debugg'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.debugg') }
            ]
          }
        },
        {
          path: '/debug2',
          name: 'debug2',
          component: (resolve) => require(['@/views/debugg/debug2'], resolve), // API调试工具
          meta: {
            requireAuth: true,
            active: 'debugg',
            noAuth: true,
            bread: [{ name: i18n.t('HT.router.debugg'), icon: 'iconappguanli' }]
          }
        },
        {
          path: '/debug3',
          name: 'debug3',
          component: (resolve) => require(['@/views/debugg/debug3'], resolve), // API调试工具
          meta: {
            requireAuth: true,
            active: 'debugg',
            noAuth: true,
            bread: [
              { name: i18n.t('HT.router.api'), icon: 'ux_icon_filter' },
              { name: i18n.t('HT.router.apiList'), icon: 'ux_icon_filter', url: '/apiList' },
              { name: i18n.t('HT.router.debugg') }
            ]
          }
        },
        // 账号列表
        {
          path: '/userList',
          name: 'userList',
          component: (resolve) => require(['@/views/userList/userList'], resolve), // 用户列表
          meta: {
            requireAuth: true,
            active: 'userList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.system'), icon: 'ux_icon_member' },
              { name: i18n.t('HT.router.userList') }
            ]
          }
        },
        {
          path: '/userInfo', // 用户详情
          name: 'userInfo',
          component: (resolve) => require(['@/views/userList/userInfo'], resolve), // 用户详情
          meta: {
            requireAuth: true,
            active: 'userList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.system'), icon: 'ux_icon_member' },
              { name: i18n.t('HT.router.userList'), icon: 'ux_icon_member', url: '/userList' },
              { name: i18n.t('HT.router.userInfo') }
            ]
          }
        },
        {
          path: '/userListGroup',
          name: 'userListGroup',
          component: (resolve) => require(['@/views/userList/userListGroup'], resolve), // 用户组
          meta: {
            requireAuth: true,
            active: 'userListGroup',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.system'), icon: 'ux_icon_member' },
              { name: i18n.t('HT.router.userListGroup') }
            ]
          }
        },
        // 国际化翻译
        {
          path: '/i18n',
          name: 'i18n',
          component: (resolve) => require(['@/views/language/language'], resolve), // 国际化翻译
          meta: {
            requireAuth: true,
            active: 'i18n',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.system'), icon: 'ux_icon_member' },
              { name: i18n.t('HT.router.i18n') }
            ]
          }
        },

        {
          path: '/jurisdiction/:id',
          name: 'jurisdiction',
          component: (resolve) => require(['@/views/userList/jurisdiction'], resolve), // 权限配置
          meta: {
            requireAuth: true,
            active: 'userListGroup',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.system'), icon: 'ux_icon_member' },
              { name: i18n.t('HT.router.userListGroup'), url: '/userListGroup' },
              { name: i18n.t('HT.router.jurisdiction') }
            ]
          }
        },
        // 用量统计
        {
          path: '/invoking',
          name: 'invoking',
          component: (resolve) => require(['@/views/statistics/invoking'], resolve), // 用量统计
          meta: {
            requireAuth: true,
            active: 'invoking',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.statistics'), icon: 'ux_icon_backstage' },
              { name: i18n.t('HT.router.invoking') }
            ]
          }
        },

        // 设备服务
        {
          path: '/deviceAccess',
          name: 'deviceAccess',
          component: (resolve) => require(['@/views/manage/deviceAccess'], resolve), // 设备接入
          meta: {
            requireAuth: true,
            active: 'deviceAccess',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.deviceServe'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.deviceAccess') }
            ]
          }
        },
        // 设备日志
        {
          path: '/deviceLog',
          name: 'deviceLog',
          component: (resolve) => require(['@/views/statistics/deviceLog'], resolve), // 设备日志
          meta: {
            requireAuth: true,
            active: 'deviceLog',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.deviceServe'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.deviceCallLog') }
            ]
          }
        },
        // 心跳日志
        {
          path: '/heartLog',
          name: 'heartLog',
          component: (resolve) => require(['@/views/statistics/heartLog'], resolve), // 心跳日志
          meta: {
            requireAuth: true,
            active: 'heartLog',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.deviceServe'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.heartLog') }
            ]
          }
        },
        // 漂移点删除
        {
          path: '/driftPoint',
          name: 'driftPoint',
          component: (resolve) => require(['@/views/statistics/driftPoint'], resolve), // 漂移点删除
          meta: {
            requireAuth: true,
            active: 'driftPoint',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.deviceServe'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.driftPoint') }
            ]
          }
        },
        {
          path: '/record',
          name: 'record',
          component: (resolve) => require(['@/views/statistics/record'], resolve), // 操作历史
          meta: {
            requireAuth: true,
            active: 'record',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.deviceServe'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.record') }
            ]
          }
        },

        // 设备调试
        {
          path: '/deviceDebug',
          name: 'deviceDebug',
          component: (resolve) => require(['@/views/manage/deviceDebug'], resolve), // 设备接入管理
          meta: {
            requireAuth: true,
            active: 'deviceDebug',
            noAuth: true,
            bread: [
              { name: i18n.t('HT.router.deviceServe'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.deviceDebug') }
            ]
          }
        },

        // 推送配置
        {
          path: '/push',
          name: 'push',
          component: (resolve) => require(['@/views/push/push'], resolve), // 推送配置
          meta: {
            requireAuth: true,
            active: 'push',
            noAuth: false,
            bread: [{ name: i18n.t('HT.router.push'), icon: 'ux_icon_refresh' }]
          }
        },

        //license管理
        {
          path: '/licenseList',
          name: 'licenseList',
          component: (resolve) => require(['@/views/license/licenseList'], resolve), // license列表
          meta: {
            requireAuth: true,
            active: 'licenseList',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.license'), icon: 'ux_icon_relation' },
              { name: i18n.t('HT.router.licenseList') }
            ]
          }
        },
        {
          path: '/licenseInfo',
          name: 'licenseInfo',
          component: (resolve) => require(['@/views/license/licenseInfo'], resolve), // license详情
          meta: {
            requireAuth: true,
            active: 'license',
            noAuth: false,
            bread: [
              {
                name: i18n.t('HT.router.licenseList'),
                icon: 'ux_icon_relation',
                url: '/licenseList'
              },
              { name: i18n.t('HT.router.licenseInfo') }
            ]
          }
        },
        // 消息服务
        {
          path: '/channelManagement',
          name: 'channelManagement',
          component: (resolve) => require(['@/views/message/channelManagement'], resolve), // 通道管理
          meta: {
            requireAuth: true,
            active: 'channelManagement',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.messageService'), icon: 'ux_icon_message' },
              { name: i18n.t('HT.router.channelManagement') }
            ]
          }
        },

        // 短信配置
        {
          path: '/msgTemplate',
          name: 'msgTemplate',
          component: (resolve) => require(['@/views/message/msgTemplate'], resolve), // 模板管理
          meta: {
            requireAuth: true,
            active: 'msgTemplate',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.msgConfig'), icon: 'ux_icon_email' },
              { name: i18n.t('HT.router.msgTemplate') }
            ]
          }
        },
        {
          path: '/sendingRestrictions',
          name: 'sendingRestrictions',
          component: (resolve) => require(['@/views/message/sendingRestrictions'], resolve), // 通用发送限制管理
          meta: {
            requireAuth: true,
            active: 'sendingRestrictions',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.msgConfig'), icon: 'ux_icon_email' },
              { name: i18n.t('HT.router.sendingRestrictions') }
            ]
          }
        },
        {
          path: '/shortMessage',
          name: 'shortMessage',
          component: (resolve) => require(['@/views/message/shortMessage'], resolve), // 短信与语言模板管理
          meta: {
            requireAuth: true,
            active: 'shortMessage',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.msgConfig'), icon: 'ux_icon_email' },
              { name: i18n.t('HT.router.shortMessage') }
            ]
          }
        },
        {
          path: '/appSendLimit',
          name: 'appSendLimit',
          component: (resolve) => require(['@/views/message/appSendLimit'], resolve), // 应用发送限制管理
          meta: {
            requireAuth: true,
            active: 'appSendLimit',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.msgConfig'), icon: 'ux_icon_email' },
              { name: i18n.t('HT.router.appSendLimit') }
            ]
          }
        },

        // AMS管理
        {
          path: '/deviceManage',
          name: 'deviceManage',
          component: (resolve) => require(['@/views/ams/deviceManage'], resolve), // 设备管理
          meta: {
            requireAuth: true,
            active: 'deviceManage',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.ams'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.deviceManage') }
            ]
          }
        },
        {
          path: '/upgradeManage',
          name: 'upgradeManage',
          component: (resolve) => require(['@/views/ams/upgradeManage'], resolve), // 升级管理
          meta: {
            requireAuth: true,
            active: 'upgradeManage',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.ams'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.upgradeManage') }
            ]
          }
        },
        {
          path: '/upgradeFiles',
          name: 'upgradeFiles',
          component: (resolve) => require(['@/views/ams/upgradeFiles'], resolve), // 升级文件
          meta: {
            requireAuth: true,
            active: 'upgradeFiles',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.ams'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.upgradeFiles') }
            ]
          }
        },
        {
          path: '/orderManage',
          name: 'orderManage',
          component: (resolve) => require(['@/views/ams/orderManage'], resolve), // 指令管理
          meta: {
            requireAuth: true,
            active: 'orderManage',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.ams'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.orderManage') }
            ]
          }
        },
        {
          path: '/realTimeLog',
          name: 'realTimeLog',
          component: (resolve) => require(['@/views/ams/realTimeLog/realTimeLog'], resolve), // 实时日志
          meta: {
            requireAuth: true,
            active: 'realTimeLog',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.ams'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.realTimeLog') }
            ]
          }
        },
        {
          path: '/imeiInfo',
          name: 'imeiInfo',
          component: (resolve) => require(['@/views/ams/realTimeLog/imeiInfo'], resolve), // 日志详情
          meta: {
            requireAuth: true,
            active: 'imeiInfo',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.realTimeLog'), icon: 'ux_icon_log', url: '/realTimeLog' },
              { name: i18n.t('HT.router.imeiInfo') }
            ]
          }
        },
        {
          path: '/netLogInfo',
          name: 'netLogInfo',
          component: (resolve) => require(['@/views/ams/realTimeLog/netLogInfo'], resolve), // 网络日志
          meta: {
            requireAuth: true,
            active: 'netLogInfo',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.realTimeLog'), icon: 'ux_icon_log', url: '/realTimeLog' },
              { name: i18n.t('HT.router.netLogInfo') }
            ]
          }
        },
        {
          path: '/parameterInfo',
          name: 'parameterInfo',
          component: (resolve) => require(['@/views/ams/realTimeLog/parameterInfo'], resolve), // 自检参数
          meta: {
            requireAuth: true,
            active: 'parameterInfo',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.realTimeLog'), icon: 'ux_icon_log', url: '/realTimeLog' },
              { name: i18n.t('HT.router.parameterInfo') }
            ]
          }
        },
        {
          path: '/temperatureInfo',
          name: 'temperatureInfo',
          component: (resolve) => require(['@/views/ams/realTimeLog/temperatureInfo'], resolve), // 电池温度
          meta: {
            requireAuth: true,
            active: 'temperatureInfo',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.realTimeLog'), icon: 'ux_icon_log', url: '/realTimeLog' },
              { name: i18n.t('HT.router.temperatureInfo') }
            ]
          }
        },
        {
          path: '/voltageInfo',
          name: 'voltageInfo',
          component: (resolve) => require(['@/views/ams/realTimeLog/voltageInfo'], resolve), // 历史电压
          meta: {
            requireAuth: true,
            active: 'voltageInfo',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.realTimeLog'), icon: 'ux_icon_log', url: '/realTimeLog' },
              { name: i18n.t('HT.router.voltageInfo') }
            ]
          }
        },

        // 实时数据管理
        {
          path: '/realDataManage',
          name: 'realDataManage',
          component: (resolve) => require(['@/views/ams/realDataManage'], resolve), // 实时数据管理
          meta: {
            requireAuth: true,
            active: 'realDataManage',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.ams'), icon: 'ux_icon_log' },
              { name: i18n.t('HT.router.realDataManage') }
            ]
          }
        },

        // 订单详情
        {
          path: '/order_overview',
          name: 'order_overview',
          component: (resolve) => require(['@/views/operation/orderOverview'], resolve), // 订单详情
          meta: {
            requireAuth: true,
            active: 'order_overview',
            noAuth: false,
            bread: [
              { name: i18n.t('HT.router.operation') },
              { name: i18n.t('HT.router.orderOverview') }
            ]
          }
        },
        ...deviceRoute,
        ...advancedServiceRoute
      ]
    },
    {
      path: '/userCenter',
      component: (resolve) => require(['@/views/userCenter'], resolve), // 首页
      meta: { requireAuth: true, noAuth: true, isUserCenterModule: true },
      redirect: '/personal',
      children: [
        {
          path: '/personal', // 账号信息
          name: 'personal',
          component: (resolve) => require(['@/views/userList/personal'], resolve), // 账号信息
          meta: {
            requireAuth: true,
            active: 'personal',
            noAuth: true,
            isUserCenterModule: true,
            bread: [
              { name: i18n.t('HT.router.userCenter') },
              { name: i18n.t('HT.router.personal') }
            ]
          }
        },
        {
          path: '/myBill', // 我的账单
          name: 'myBill',
          component: (resolve) => require(['@/views/userList/myBill'], resolve), // 我的账单
          meta: {
            requireAuth: true,
            active: 'myBill',
            noAuth: true,
            isUserCenterModule: true,
            bread: [{ name: i18n.t('HT.router.userCenter') }, { name: i18n.t('HT.router.myBill') }]
          }
        }
      ]
    },
    {
      path: '/workOrder',
      component: (resolve) => require(['@/views/workOrder/workOrder'], resolve), // 首页
      meta: { requireAuth: true, active: 'workOrder', isWorkOrderModule: true }
    },
    {
      path: '/404',
      name: '404',
      component: (resolve) => require(['@/views/warning/404'], resolve)
    },
    {
      path: '/error',
      name: 'error',
      component: (resolve) => require(['@/views/warning/error'], resolve)
    },
    {
      path: '*',
      component: (resolve) => require(['@/views/warning/404'], resolve)
    },
    // 隐私协议
    {
      path: '/privacyAgreement',
      name: 'privacyAgreement',
      component: (resolve) => require(['@/views/login/privacyAgreement'], resolve) // 隐私协议
    },
    // 用户协议
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: (resolve) => require(['@/views/login/userAgreement'], resolve) // 用户协议
    }
    // {
    //     path: '/test',
    //     component: resolve => require(['@/views/test'], resolve)
    // },
  ];
};
/**
   * requireAuth: 需要登录才可以访问
   * active: 当前路由激活的菜单
   * noAuth: 不需要菜单授权, 登录后可直接访问
   * bread: 面包屑数据
   */
const router = new Router({
  // mode: 'history',
  routes: getRoutes()
});

router.beforeEach((to, from, next) => {
  Vue.prototype.$showModal.hide();
  if (to.meta.requireAuth) {
    // 判断该页面是否需要登录
    if (store.state.login.token) {
      if (localStorage.getItem('redirectAfterLogin')) {
        let redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
        localStorage.removeItem('redirectAfterLogin');
        next(redirectAfterLogin); // 清除存储的路径
        return;
      }
      // 判断token是否存在
      if (to.meta.noAuth) {
        // 不需菜单授权 (如账号信息页面)
        next();
        return;
      }
      let menu = getLocalStorage('userMenu');
      console.log('menu', menu, to.meta.active);
      if (menu.indexOf(to.meta.active) > -1) {
        next();
      } else {
        next('/404'); // 无权限访问
      }
    } else {
      console.log('123123debugggggg');
      // 存储访问的路径做跳转
      localStorage.setItem('redirectAfterLogin', to.fullPath);
      next('/login'); // 未登录-去登录
    }
  } else {
    // 不需要登录-直接访问
    next();
  }
});
export default router;
